import { apiSlice } from '../apiSlice';

const debugEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    buildScanData: builder.mutation<string, string>({
      query(id) {
        return {
          url: `scandata/${id}`,
          method: 'POST',
        };
      },
    }),
  }),
});

export const { useBuildScanDataMutation } = debugEndpoints;
